import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  // Accordion,
  // AccordionSummary,
  // AccordionDetails,
  // Slider,
  withStyles,
  FormControlLabel,
  Checkbox,
  Hidden,
  useMediaQuery,
  useTheme,
  Divider,
} from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroll-component";
import BodyText from "../../components/reusableComponents/BodyText";
import HeaderSection from "../../components/reusableComponents/HeaderSection";
import { toggleFlightModal, setFlightId } from "../../reducers/UiReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  SearchReturnFormIntDispatch,
  SearchReturnEtravFormDispatch,
  AddSearchFlightDispatch,
  FlightFareRuleDispatch,
} from "../../reducers/HomeReducer";
import Slider from "@mui/material/Slider";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useHistory, useLocation } from "react-router-dom";
import SkeletonOneway from "../../components/reusableComponents/SkeletonOneway";
import OneWayFlightForm from "../../form/OneWayFlightForm";
import FlightDetailModal from "../../components/reusableComponents/FlightDetailModal";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiChip-sizeSmall": {
      height: 36,
    },
  },
  accodin: {
    "& .MuiAccordionSummary-content": {
      justifyContent: "space-between",
    },
  },
  searhform: {
    paddingTop: 84,
    paddingBottom: 30,
    backgroundColor: "midnightblue",
    [theme.breakpoints.down("md")]: {
      height: 508,
    },
    [theme.breakpoints.down("xs")]: {
      height: 590,
    },
  },
  radio: {
    "& .MuiTypography-body1": {
      fontSize: 13,
    },
  },
}));
const GreenCheckbox = withStyles({
  root: {
    color: "rgb(239, 51, 57)",
    "&$checked": {
      color: "rgb(239, 51, 57)",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
const International = () => {
  const { flightreturnInt, loading, orderID, currency,lint } = useSelector(
    (state) => state.home
  );
  const { selectedOrigin, selectedDepart, curr } = useSelector(
    (state) => state.ui
  );
  const [value, setValue] = React.useState([1000, 100000]);
  const [scrollVal, SetScrollVal] = useState(10);
  const [data, setData] = useState(false);
  const history = useHistory();
  const theme = useTheme();
  const [rule, SetRule] = useState(false);
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [out, setOut] = useState(true);
  const [rf, setRf] = useState(true);
  const [stopcheck1, setStopCheck1] = useState(false);
  const [stopcheck2, setStopCheck2] = useState(false);
  const [stopcheck3, setStopCheck3] = useState(false);
  const [info, setInfo] = useState("fare");
  const classes = useStyles();
  const [result, setResult] = useState([]);
  const [airlineS, setairlineS] = useState(false);
  const [airlineG, setairlineG] = useState(false);
  const [airlineI, setairlineI] = useState(false);
  const [airlineA, setairlineA] = useState(false);
  const [airlineV, setairlineV] = useState(false);
  const [refund, setRefund] = useState(false);
  const [nrefund, setNRefund] = useState(false);
  const dispatch = useDispatch();
  const [stp, setStp] = useState(true);
  const [air, setAir] = useState(true);
  const [scrollValResult, SetScrollValResult] = useState(10);
  const [hasMoreresult, SethasMoreResult] = useState(true);
  const [hasMorefilterData, SethasMoreFilterData] = useState(true);

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleInfo = (value) => {
    setInfo(value);
  };
  const fetchMoreData = () => {
    if (scrollVal >= filterData.length) {
      SethasMoreFilterData(false);
    }

    setTimeout(() => {
      SetScrollVal(scrollVal + 5);
    }, 500);
  };
  const fetchMoreDataResult = () => {
    if (scrollValResult >= 200) {
      SethasMoreResult(false);
    }
    setTimeout(() => {
      SetScrollValResult(scrollValResult + 5);
    }, 500);
  };
  const handleStop = (event) => {
    setStopCheck1(event.target.checked);

    if (stopcheck1) {
      setResult([]);
      SetRule(event.target.checked);
    } else {
      SetRule(event.target.checked);
      console.log(event.target.name);
      let filterCombineStop = [];
      let filterDataStop = [];
      let tbo = [];

      if (flightreturnInt) {
        flightreturnInt &&
          flightreturnInt.result &&
          flightreturnInt.result.Response &&
          flightreturnInt.result.Response.Results[0].length > 0 &&
          flightreturnInt.result.Response.Results[0].map((item) => {
            if (item.Segments[0].length === 1) {
              tbo.push({
                ...item,
              });
            }
          });
      }

      filterCombineStop = [...tbo];
      console.log("Combine", filterCombineStop);
      filterDataStop =
        filterCombineStop &&
        filterCombineStop.length > 0 &&
        filterCombineStop.slice().sort((a, b) => {
          let first = a.Fare
            ? Number(
                Number(Math.round(a.Fare.Total_Amount)) -
                  Number(Math.round(a.Fare.MFB_Discount))
              )
            : "";
          let second = b.Fare
            ? Number(
                Number(Math.round(b.Fare.Total_Amount)) -
                  Number(Math.round(b.Fare.MFB_Discount))
              )
            : "";
          return first - second;
        });
      console.log("stop3", filterDataStop);
      setResult(filterDataStop);
    }
  };
  const handleStop2 = (event) => {
    setStopCheck2(event.target.checked);

    if (stopcheck2) {
      setResult([]);
      SetRule(event.target.checked);
    } else {
      SetRule(event.target.checked);
      console.log(event.target.name);
      let filterCombineStop = [];
      let filterDataStop = [];
      let tbo = [];

      if (flightreturnInt) {
        flightreturnInt &&
          flightreturnInt.result &&
          flightreturnInt.result.Response &&
          flightreturnInt.result.Response.Results[0].length > 0 &&
          flightreturnInt.result.Response.Results[0].map((item) => {
            if (item.Segments[0].length === 2) {
              tbo.push({
                ...item,
              });
            }
          });
      }

      filterCombineStop = [...tbo];
      console.log("Combine", filterCombineStop);
      filterDataStop =
        filterCombineStop &&
        filterCombineStop.length > 0 &&
        filterCombineStop.slice().sort((a, b) => {
          let first = a.Fare
            ? Number(
                Number(Math.round(a.Fare.Total_Amount)) -
                  Number(Math.round(a.Fare.MFB_Discount))
              )
            : "";
          let second = b.Fare
            ? Number(
                Number(Math.round(b.Fare.Total_Amount)) -
                  Number(Math.round(b.Fare.MFB_Discount))
              )
            : "";
          return first - second;
        });
      console.log("stop3", filterDataStop);
      setResult(filterDataStop);
    }
  };
  const handleStop3 = (event) => {
    setStopCheck3(event.target.checked);

    if (stopcheck3) {
      setResult([]);
      SetRule(event.target.checked);
    } else {
      SetRule(event.target.checked);
      console.log(event.target.name);
      let filterCombineStop = [];
      let filterDataStop = [];
      let tbo = [];

      if (flightreturnInt) {
        flightreturnInt &&
          flightreturnInt.result &&
          flightreturnInt.result.Response &&
          flightreturnInt.result.Response.Results[0].length > 0 &&
          flightreturnInt.result.Response.Results[0].map((item) => {
            if (item.Segments[0].length > 2) {
              tbo.push({
                ...item,
              });
            }
          });
      }

      filterCombineStop = [...tbo];
      console.log("Combine", filterCombineStop);
      filterDataStop =
        filterCombineStop &&
        filterCombineStop.length > 0 &&
        filterCombineStop.slice().sort((a, b) => {
          let first = a.Fare
            ? Number(
                Number(Math.round(a.Fare.Total_Amount)) -
                  Number(Math.round(a.Fare.MFB_Discount))
              )
            : "";
          let second = b.Fare
            ? Number(
                Number(Math.round(b.Fare.Total_Amount)) -
                  Number(Math.round(b.Fare.MFB_Discount))
              )
            : "";
          return first - second;
        });
      console.log("stop3", filterDataStop);
      setResult(filterDataStop);
    }
  };
  const handleAirline = (event) => {
    if (event.target.name === "SG") {
      setairlineS(event.target.checked);
    } else if (event.target.name === "G8") {
      setairlineG(event.target.checked);
    } else if (event.target.name === "6E") {
      setairlineI(event.target.checked);
    } else if (event.target.name === "I5") {
      setairlineA(event.target.checked);
    } else if (event.target.name === "UK") {
      setairlineV(event.target.checked);
    }

    if (airlineA || airlineG || airlineI || airlineS || airlineV) {
      setResult([]);
      SetRule(event.target.checked);
    } else {
      SetRule(event.target.checked);
      console.log(event.target.name);
      let filterCombineStop = [];
      let filterDataStop = [];
      let tbo = [];

      if (flightreturnInt) {
        flightreturnInt &&
          flightreturnInt.result &&
          flightreturnInt.result.Response &&
          flightreturnInt.result.Response.Results[0].length > 0 &&
          flightreturnInt.result.Response.Results[0].map((item) => {
            if (item.AirlineCode === event.target.name) {
              tbo.push({
                ...item,
              });
            }
          });
      }

      filterCombineStop = [...tbo];
      console.log("Combine", filterCombineStop);
      filterDataStop =
        filterCombineStop &&
        filterCombineStop.length > 0 &&
        filterCombineStop.slice().sort((a, b) => {
          let first = a.Fare
            ? Number(
                Number(Math.round(a.Fare.Total_Amount)) -
                  Number(Math.round(a.Fare.MFB_Discount))
              )
            : "";
          let second = b.Fare
            ? Number(
                Number(Math.round(b.Fare.Total_Amount)) -
                  Number(Math.round(b.Fare.MFB_Discount))
              )
            : "";
          return first - second;
        });
      console.log("filterAilrine", filterDataStop);
      setResult(filterDataStop);
    }
  };
  const handleFareR = (event) => {
    setRefund(event.target.checked);

    if (refund) {
      setResult([]);
      SetRule(event.target.checked);
    } else {
      SetRule(event.target.checked);
      let filterCombineStop = [];
      let filterDataStop = [];
      let tbo = [];

      if (flightreturnInt) {
        flightreturnInt &&
          flightreturnInt.result &&
          flightreturnInt.result.Response &&
          flightreturnInt.result.Response.Results[0].length > 0 &&
          flightreturnInt.result.Response.Results[0].map((item) => {
            if (item.IsRefundable) {
              tbo.push({
                ...item,
              });
            }
          });
      }

      filterCombineStop = [...tbo];
      console.log("Combine", filterCombineStop);
      filterDataStop =
        filterCombineStop &&
        filterCombineStop.length > 0 &&
        filterCombineStop.slice().sort((a, b) => {
          let first = a.Fare
            ? Number(
                Number(Math.round(a.Fare.Total_Amount)) -
                  Number(Math.round(a.Fare.MFB_Discount))
              )
            : "";
          let second = b.Fare
            ? Number(
                Number(Math.round(b.Fare.Total_Amount)) -
                  Number(Math.round(b.Fare.MFB_Discount))
              )
            : "";
          return first - second;
        });
      console.log("stop3", filterDataStop);
      setResult(filterDataStop);
    }
  };
  const handleFareN = (event) => {
    setNRefund(event.target.checked);

    if (nrefund) {
      setResult([]);
      SetRule(event.target.checked);
    } else {
      SetRule(event.target.checked);
      let filterCombineStop = [];
      let filterDataStop = [];
      let tbo = [];

      if (flightreturnInt) {
        flightreturnInt &&
          flightreturnInt.result &&
          flightreturnInt.result.Response &&
          flightreturnInt.result.Response.Results[0].length > 0 &&
          flightreturnInt.result.Response.Results[0].map((item) => {
            if (!item.IsRefundable) {
              tbo.push({
                ...item,
              });
            }
          });
      }

      filterCombineStop = [...tbo];
      console.log("Combine", filterCombineStop);
      filterDataStop =
        filterCombineStop &&
        filterCombineStop.length > 0 &&
        filterCombineStop.slice().sort((a, b) => {
          let first = a.Fare
            ? Number(
                Number(Math.round(a.Fare.Total_Amount)) -
                  Number(Math.round(a.Fare.MFB_Discount))
              )
            : "";
          let second = b.Fare
            ? Number(
                Number(Math.round(b.Fare.Total_Amount)) -
                  Number(Math.round(b.Fare.MFB_Discount))
              )
            : "";
          return first - second;
        });
      console.log("stop3", filterDataStop);
      setResult(filterDataStop);
    }
  };
  const location = useLocation();
  console.log("lo", location);
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr and " + rminutes + " min.";
  }
  let filterData = [];
  let flt = [];
  if (lint) {
    console.log("lint");
  } else {
    let tbo =
      flightreturnInt &&
      flightreturnInt?.result &&
      flightreturnInt?.result?.Response &&
      flightreturnInt?.result?.Response?.Results[0];
    if (tbo?.length > 0) {
      filterData = [...tbo];
    }
  }
  useEffect(() => {
    if (location.state) {
      dispatch(SearchReturnFormIntDispatch(location.state.returnBody));
      // dispatch(SearchReturnEtravFormDispatch(location.state.returnBody));
      dispatch(AddSearchFlightDispatch(location.state.returnBody));
      window.scrollTo(0, 0);
    }
  }, [dispatch]);
  return (
    <>
      <HeaderSection id={1} />
      {true ? (
        <Box
          styel={{ transition: "all 0.5s ease" }}
          className={classes.searhform}
        >
          <Container>
            <OneWayFlightForm />
          </Container>
        </Box>
      ) : (
        ""
      )}
      <Box style={{ padding: 10 }}>
        <Grid container style={{ marginTop: 10 }} spacing={2}>
          <Grid item xs={12} lg={3}>
            <Box
              style={{
                padding: 15,
                boxShadow: "0 3px 30px 0 rgb(0 0 0 / 10%)",
                background: "white",
                borderRadius: 5,
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" alignItems="center">
                  <i
                    class="fa fa-search"
                    style={{ margin: 6, fontSize: 20 }}
                  ></i>
                  <span style={{ fontSize: 15 }}>Filter</span>
                </Box>
                <p style={{ fontSize: 13 }}>
                  <u>Clear all filters</u>
                </p>
              </Box>
              <Box
                style={{
                  background: "#E0DEDE",
                  padding: 5,
                  cursor: "pointer",
                  marginTop: 20,
                }}
                onClick={() => (stp ? setStp(false) : setStp(true))}
              >
                <b style={{ fontWeight: "bold" }}>
                  {" "}
                  <span
                    class="air_down_icon"
                    id="icon_dept"
                    style={{ fontSize: 14 }}
                  >
                    ▼
                  </span>
                  Stops:
                </b>
              </Box>
              {stp ? (
                <>
                  {" "}
                  <Box
                    mt={matches ? "20px" : ""}
                    className={classes.radio}
                    style={{
                      border: "1px solid lightgrey",
                      padding: "10px",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={stopcheck1}
                          onChange={handleStop}
                          name="1"
                        />
                      }
                      label="Direct"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={stopcheck2}
                          onChange={handleStop2}
                          name="2"
                        />
                      }
                      label="1"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={stopcheck3}
                          onChange={handleStop3}
                          name="3"
                        />
                      }
                      label="2 & more"
                    />
                  </Box>
                </>
              ) : (
                ""
              )}
              <Divider style={{ marginTop: 20 }} />
              <Box
                style={{
                  background: "#E0DEDE",
                  padding: 5,
                  cursor: "pointer",
                }}
                onClick={() => (air ? setAir(false) : setAir(true))}
              >
                <b style={{ fontWeight: "bold" }}>
                  {" "}
                  <span
                    class="air_down_icon"
                    id="icon_dept"
                    style={{ fontSize: 14 }}
                  >
                    ▼
                  </span>
                  Airlines:
                </b>
              </Box>
              {air ? (
                <>
                  {" "}
                  <Box
                    mt={matches ? "20px" : ""}
                    className={classes.radio}
                    style={{
                      border: "1px solid lightgrey",
                      padding: "10px",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={airlineS}
                          onChange={handleAirline}
                          name="SG"
                        />
                      }
                      label="SpiceJet"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={airlineG}
                          onChange={handleAirline}
                          name="G8"
                        />
                      }
                      label="GO FIRST"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={airlineI}
                          onChange={handleAirline}
                          name="6E"
                        />
                      }
                      label="Indigo"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={airlineA}
                          onChange={handleAirline}
                          name="I5"
                        />
                      }
                      label="Air Asia"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={airlineV}
                          onChange={handleAirline}
                          name="UK"
                        />
                      }
                      label="Vistara"
                    />
                    <br />
                  </Box>
                </>
              ) : (
                ""
              )}
              <Divider style={{ marginTop: 20 }} />
              <Box
                style={{
                  background: "#E0DEDE",
                  padding: 5,
                  cursor: "pointer",
                }}
                onClick={() => (out ? setOut(false) : setOut(true))}
              >
                <b style={{ fontWeight: "bold" }}>
                  {" "}
                  <span
                    class="air_down_icon"
                    id="icon_dept"
                    style={{ fontSize: 14 }}
                  >
                    ▼
                  </span>
                  Outbound Flight Times:
                </b>
              </Box>
              {out ? (
                <>
                  {" "}
                  <Box
                    mt={matches ? "20px" : ""}
                    className={classes.radio}
                    style={{
                      border: "1px solid lightgrey",
                      padding: "10px",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          // checked={morning}
                          // onChange={handleMorning}
                          name="Morning"
                        />
                      }
                      label="Morning(04:00-11:00)"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          // checked={check2}
                          // onChange={handleCheckGO}
                          name="G8"
                        />
                      }
                      label="Afternoon(11:00-16:00)"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          // checked={check3}
                          // onChange={handleCheckIndigo}
                          name="6E"
                        />
                      }
                      label="Evening(16:00-21:00)"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          // checked={check4}
                          // onChange={handleCheckAir}
                          name="I5"
                        />
                      }
                      label="Night(21:00-04:00)"
                    />

                    <br />
                  </Box>
                </>
              ) : (
                ""
              )}
              <Divider style={{ marginTop: 20 }} />
              <Box
                style={{
                  background: "#E0DEDE",
                  padding: 5,
                  cursor: "pointer",
                }}
                onClick={() => (rf ? setRf(false) : setRf(true))}
              >
                <b style={{ fontWeight: "bold" }}>
                  {" "}
                  <span
                    class="air_down_icon"
                    id="icon_dept"
                    style={{ fontSize: 14 }}
                  >
                    ▼
                  </span>
                  Fare Type
                </b>
              </Box>
              {rf ? (
                <>
                  {" "}
                  <Box
                    mt={matches ? "20px" : ""}
                    className={classes.radio}
                    style={{
                      border: "1px solid lightgrey",
                      padding: "10px",
                      transition: "all 0.3s ease-in-out",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={refund}
                          onChange={handleFareR}
                          name="Refundable"
                        />
                      }
                      label="Refundable"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <GreenCheckbox
                          checked={nrefund}
                          onChange={handleFareN}
                          name="Non"
                        />
                      }
                      label="Non-Refundable"
                    />
                  </Box>
                </>
              ) : (
                ""
              )}
            </Box>
          </Grid>
          <Grid item xs={12} lg={9}>
            <h3>{`Flights from ${selectedOrigin.city_name} to ${
              selectedDepart.city_name
            }(${filterData ? filterData.length : 0})`}</h3>
            {lint ? (
              [0, 1, 2, 3, 4].map((i) => {
                return <SkeletonOneway />;
              })
            ) : rule || (result && result.length > 0) ? (
              result && result.length > 0 ? (
                <InfiniteScroll
                  dataLength={scrollValResult}
                  next={fetchMoreDataResult}
                  hasMore={hasMoreresult}
                  loader={<h4>Loading...</h4>}
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      <b>No More Flights</b>
                    </p>
                  }
                >
                  {result.map((item, index) => {
                    return index < scrollValResult ? (
                      <>
                        <Accordion
                          style={{ marginTop: 10 }}
                          expanded={expanded === `panel${index + 1}`}
                          onChange={handleChange(`panel${index + 1}`)}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <Box
                                  alignItems="center"
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box style={{ display: "flex" }}>
                                    <img
                                      width="50px"
                                      height="50px"
                                      src={`https://nitish.musafirbazar.com/static/media/${item.Segments[0]
                                        .slice(0, 1)
                                        .map((i) => {
                                          return i.Airline.AirlineCode;
                                        })}.gif`}
                                    />
                                    <Box ml={"10px"}>
                                      <span>
                                        {item.Segments[0]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineName;
                                          })}
                                      </span>
                                      <br></br>
                                      <span>
                                        {item.Segments[0]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineCode;
                                          })}
                                      </span>
                                    </Box>
                                  </Box>
                                  <Box>
                                    <Box display="flex">
                                      <span style={{ fontWeight: "bold" }}>
                                        {item.Origin
                                          ? item.Origin
                                          : item.FareRules[0].Origin}
                                      </span>
                                      <span
                                        style={{
                                          marginLeft: 5,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        -
                                      </span>
                                      <span
                                        style={{
                                          marginLeft: 5,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {" "}
                                        {item.Airline_Code
                                          ? item.Segments.length === 1
                                            ? item.Segments.filter(
                                                (i, index) => index === 0
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : item.Segments.length === 2
                                            ? item.Segments.filter(
                                                (i, index) => index === 1
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : item.Segments.length === 3
                                            ? item.Segments.filter(
                                                (i, index) => index === 2
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : ""
                                          : item.Segments[0].length == 2
                                          ? item.Segments[0]
                                              .filter((i, index) => index === 1)
                                              .map((it) => {
                                                return it.Destination.Airport
                                                  .AirportCode;
                                              })
                                          : item.Segments[0].length == 3
                                          ? item.Segments[0]
                                              .filter((i, index) => index === 2)
                                              .map((it) => {
                                                return it.Destination.Airport
                                                  .AirportCode;
                                              })
                                          : item.Segments[0].length == 1
                                          ? item.Segments[0].map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                          : ""}
                                      </span>
                                      {/* <br></br> */}
                                    </Box>
                                    <span
                                      style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                      }}
                                    >
                                      {item.Airline_Code
                                        ? item.Segments[0].Departure_DateTime.substr(
                                            11,
                                            5
                                          )
                                        : item.AirlineCode
                                        ? item.Segments[0]
                                            .slice(0, 1)
                                            .map((i) => {
                                              return i.Origin.DepTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : ""}
                                      {/* {item.Segments[0].slice} */}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                      }}
                                    >
                                      -
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                      }}
                                    >
                                      {item.Airline_Code
                                        ? item.Segments.length === 1
                                          ? item.Segments.filter(
                                              (i, index) => index === 0
                                            ).map((it) => {
                                              return it.Departure_DateTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                          : item.Segments.length === 2
                                          ? item.Segments.filter(
                                              (i, index) => index === 1
                                            ).map((it) => {
                                              return it.Departure_DateTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                          : item.Segments.length === 3
                                          ? item.Segments.filter(
                                              (i, index) => index === 2
                                            ).map((it) => {
                                              return it.Departure_DateTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                          : ""
                                        : item.AirlineCode
                                        ? item.Segments[0].length == 3
                                          ? item.Segments[0]
                                              .filter((i, index) => index === 2)
                                              .map((i) => {
                                                return i.Destination.ArrTime.substr(
                                                  11,
                                                  5
                                                );
                                              })
                                          : item.Segments[0].length == 2
                                          ? item.Segments[0]
                                              .filter((i, index) => index === 1)
                                              .map((i) => {
                                                return i.Destination.ArrTime.substr(
                                                  11,
                                                  5
                                                );
                                              })
                                          : item.Segments[0].length == 1
                                          ? item.Segments[0]
                                              .filter((i, index) => index === 0)
                                              .map((i) => {
                                                return i.Destination.ArrTime.substr(
                                                  11,
                                                  5
                                                );
                                              })
                                          : ""
                                        : ""}
                                    </span>
                                  </Box>

                                  <Box
                                    style={{ display: "flex" }}
                                    onClick={() =>
                                      data ? setData(false) : setData(true)
                                    }
                                  >
                                    <img
                                      width="50px"
                                      height="50px"
                                      src={`https://nitish.musafirbazar.com/static/media/${item.Segments[1]
                                        .slice(0, 1)
                                        .map((i) => {
                                          return i.Airline.AirlineCode;
                                        })}.gif`}
                                    />
                                    <Box ml={"10px"}>
                                      <span>
                                        {item.Segments[1]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineName;
                                          })}
                                      </span>
                                      <br></br>
                                      <span>
                                        {item.Segments[1]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Airline.AirlineCode;
                                          })}
                                      </span>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                              <Grid item xs={6}>
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box>
                                    <Box display="flex">
                                      <span style={{ fontWeight: "bold" }}>
                                        {item.Segments[1]
                                          .slice(0, 1)
                                          .map((it) => {
                                            return it.Origin.Airport
                                              .AirportCode;
                                          })}
                                      </span>
                                      <span
                                        style={{
                                          marginLeft: 5,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        -
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: "bold",
                                          marginLeft: 5,
                                        }}
                                      >
                                        {" "}
                                        {item.Airline_Code
                                          ? item.Segments.length === 1
                                            ? item.Segments.filter(
                                                (i, index) => index === 0
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : item.Segments.length === 2
                                            ? item.Segments.filter(
                                                (i, index) => index === 1
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : item.Segments.length === 3
                                            ? item.Segments.filter(
                                                (i, index) => index === 2
                                              ).map((it) => {
                                                return it.Destination;
                                              })
                                            : ""
                                          : item.Segments[1].length == 2
                                          ? item.Segments[1]
                                              .filter((i, index) => index === 1)
                                              .map((it) => {
                                                return it.Destination.Airport
                                                  .AirportCode;
                                              })
                                          : item.Segments[1].length == 3
                                          ? item.Segments[1]
                                              .filter((i, index) => index === 2)
                                              .map((it) => {
                                                return it.Destination.Airport
                                                  .AirportCode;
                                              })
                                          : item.Segments[1].length == 1
                                          ? item.Segments[1].map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                          : ""}
                                      </span>
                                      <br></br>
                                    </Box>
                                    <span
                                      style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                      }}
                                    >
                                      {item.Airline_Code
                                        ? item.Segments[1].Departure_DateTime.substr(
                                            11,
                                            5
                                          )
                                        : item.AirlineCode
                                        ? item.Segments[1]
                                            .slice(0, 1)
                                            .map((i) => {
                                              return i.Origin.DepTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : ""}
                                      {/* {item.Segments[0].slice} */}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                      }}
                                    >
                                      -
                                    </span>
                                    <span
                                      style={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                      }}
                                    >
                                      {item.Airline_Code
                                        ? item.Segments.length === 1
                                          ? item.Segments.filter(
                                              (i, index) => index === 0
                                            ).map((it) => {
                                              return it.Departure_DateTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                          : item.Segments.length === 2
                                          ? item.Segments.filter(
                                              (i, index) => index === 1
                                            ).map((it) => {
                                              return it.Departure_DateTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                          : item.Segments.length === 3
                                          ? item.Segments.filter(
                                              (i, index) => index === 2
                                            ).map((it) => {
                                              return it.Departure_DateTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                          : ""
                                        : item.AirlineCode
                                        ? item.Segments[1].length == 3
                                          ? item.Segments[1]
                                              .filter((i, index) => index === 2)
                                              .map((i) => {
                                                return i.Destination.ArrTime.substr(
                                                  11,
                                                  5
                                                );
                                              })
                                          : item.Segments[1].length == 2
                                          ? item.Segments[1]
                                              .filter((i, index) => index === 1)
                                              .map((i) => {
                                                return i.Destination.ArrTime.substr(
                                                  11,
                                                  5
                                                );
                                              })
                                          : item.Segments[1].length == 1
                                          ? item.Segments[1]
                                              .filter((i, index) => index === 0)
                                              .map((i) => {
                                                return i.Destination.ArrTime.substr(
                                                  11,
                                                  5
                                                );
                                              })
                                          : ""
                                        : ""}
                                    </span>
                                  </Box>

                                  {/* <Box>
                       
                      </Box> */}

                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                  >
                                    {item.IsRefundable ? (
                                      <Box
                                        style={{
                                          border: "1px solid #2dca1c",
                                          padding: "2px 8px",
                                        }}
                                      >
                                        <span style={{ color: "#2dca1c" }}>
                                          R
                                        </span>
                                      </Box>
                                    ) : (
                                      <Box
                                        style={{
                                          border: "1px solid red",
                                          padding: "2px 8px",
                                        }}
                                      >
                                        <span style={{ color: "red" }}>N</span>
                                      </Box>
                                    )}
                                    <h3 style={{ marginLeft: 10 }}>
                                      {curr}{" "}
                                      {Number(
                                        Math.round(
                                          Number(
                                            Math.round(item.Fare.Total_Amount)
                                          )
                                        )
                                      )}
                                    </h3>
                                    <Box
                                      onClick={() => {
                                        history.push({
                                          pathname: "/summaryflight",
                                          state: {
                                            orderID: orderID?.result,
                                            // flightData:
                                            //   resultSelection.length == 1
                                            //     ? resultSelection
                                            //     : onward.length == 1
                                            //     ? onward
                                            //     : "",
                                            // selectedonward:
                                            //   selectedonward.length == 1
                                            //     ? selectedonward
                                            //     : "",
                                            // selectedReturn:
                                            //   selectedReturn.length == 1
                                            //     ? selectedReturn
                                            //     : "",

                                            // Returnflight:
                                            //   resultRSelection.length == 1
                                            //     ? resultRSelection
                                            //     : returnD.length == 1
                                            //     ? returnD
                                            //     : "",
                                            returnBody:
                                              location.state.returnBody,
                                            intFlight: item,
                                            // ID:
                                            //   flightreturn &&
                                            //   flightreturn.result &&
                                            //   flightreturn.result.Response &&
                                            //   flightreturn.result.Response.TraceId,
                                            IDTBO:
                                              flightreturnInt &&
                                              flightreturnInt.result &&
                                              flightreturnInt.result.Response &&
                                              flightreturnInt.result.Response
                                                .TraceId,
                                            // IDEtrav:
                                            //   roundTripEtrav &&
                                            //   roundTripEtrav.result &&
                                            //   roundTripEtrav.result.Search_Key,
                                          },
                                        });
                                      }}
                                      textAlign="center"
                                      style={{
                                        marginLeft: 20,
                                        background: "#ef631e",
                                        color: "white",
                                        borderRadius: "5px",
                                        padding: "0px 10px",
                                      }}
                                    >
                                      <h3>Book Now</h3>
                                    </Box>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                {" "}
                                <Box
                                  style={{ marginTop: 25 }}
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <span>Depart</span>
                                  <Box>
                                    <span>Duration:</span>
                                    <span style={{ marginLeft: 10 }}>
                                      {timeConvert(
                                        item.AirlineCode
                                          ? item.Segments[0].length == 2
                                            ? Number(
                                                item.Segments[0]
                                                  .filter(
                                                    (i, index) => index === 0
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              ) +
                                              Number(
                                                item.Segments[0]
                                                  .filter(
                                                    (i, index) => index === 1
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              )
                                            : item.Segments[0].length == 1
                                            ? item.Segments[0].map(
                                                (i) => i.Duration
                                              )
                                            : item.Segments[0].length == 3
                                            ? Number(
                                                item.Segments[0]
                                                  .filter(
                                                    (i, index) => index === 0
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              ) +
                                              Number(
                                                item.Segments[0]
                                                  .filter(
                                                    (i, index) => index === 1
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              ) +
                                              Number(
                                                item.Segments[0]
                                                  .filter(
                                                    (i, index) => index === 2
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              )
                                            : ""
                                          : ""
                                      )}
                                    </span>
                                  </Box>
                                </Box>
                                <Box
                                  style={{
                                    padding: 10,
                                    border: "1px solid #ebe5e5",
                                  }}
                                >
                                  {item.Segments[0].map((i) => {
                                    return (
                                      <>
                                        <Box
                                          display="flex"
                                          style={{ marginTop: 10 }}
                                          justifyContent="space-between"
                                        >
                                          {" "}
                                          <Box>
                                            <span>
                                              {i.Origin.Airport.AirportCode}
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Origin.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Origin.DepTime.substr(11, 5)}
                                            </span>
                                          </Box>
                                          <Box style={{ textAlign: "center" }}>
                                            <span>
                                              {timeConvert(i.Duration)}
                                            </span>
                                            <div className="ln"></div>
                                            <br></br>
                                            <span style={{ marginLeft: 5 }}>
                                              Non Stop
                                            </span>
                                          </Box>
                                          <Box>
                                            <span>
                                              {
                                                i.Destination.Airport
                                                  .AirportCode
                                              }
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Destination.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              )}
                                            </span>
                                          </Box>
                                        </Box>
                                      </>
                                    );
                                  })}
                                </Box>
                              </Grid>
                              <Grid item xs={6}>
                                {" "}
                                <Box
                                  style={{ marginTop: 25 }}
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <span>Return</span>
                                  <Box>
                                    <span>Duration:</span>
                                    <span style={{ marginLeft: 10 }}>
                                      {timeConvert(
                                        item.AirlineCode
                                          ? item.Segments[1].length == 2
                                            ? Number(
                                                item.Segments[1]
                                                  .filter(
                                                    (i, index) => index === 0
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              ) +
                                              Number(
                                                item.Segments[1]
                                                  .filter(
                                                    (i, index) => index === 1
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              )
                                            : item.Segments[1].length == 1
                                            ? item.Segments[1].map(
                                                (i) => i.Duration
                                              )
                                            : item.Segments[1].length == 3
                                            ? Number(
                                                item.Segments[1]
                                                  .filter(
                                                    (i, index) => index === 0
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              ) +
                                              Number(
                                                item.Segments[1]
                                                  .filter(
                                                    (i, index) => index === 1
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              ) +
                                              Number(
                                                item.Segments[1]
                                                  .filter(
                                                    (i, index) => index === 2
                                                  )
                                                  .map((it) => {
                                                    return it.Duration;
                                                  })
                                              )
                                            : ""
                                          : ""
                                      )}
                                    </span>
                                  </Box>
                                </Box>
                                <Box
                                  style={{
                                    padding: 10,
                                    border: "1px solid #ebe5e5",
                                  }}
                                >
                                  {item.Segments[1].map((i) => {
                                    return (
                                      <>
                                        <Box
                                          display="flex"
                                          style={{ marginTop: 10 }}
                                          justifyContent="space-between"
                                        >
                                          {" "}
                                          <Box>
                                            <span>
                                              {i.Origin.Airport.AirportCode}
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Origin.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Origin.DepTime.substr(11, 5)}
                                            </span>
                                          </Box>
                                          <Box style={{ textAlign: "center" }}>
                                            <span>
                                              {timeConvert(i.Duration)}
                                            </span>
                                            <div className="ln"></div>
                                            <br></br>
                                            <span style={{ marginLeft: 5 }}>
                                              Non Stop
                                            </span>
                                          </Box>
                                          <Box>
                                            <span>
                                              {
                                                i.Destination.Airport
                                                  .AirportCode
                                              }
                                            </span>
                                            <span style={{ marginLeft: 5 }}>
                                              ({i.Destination.Airport.CityName})
                                            </span>
                                            <span
                                              style={{
                                                marginLeft: 5,
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              )}
                                            </span>
                                          </Box>
                                        </Box>
                                      </>
                                    );
                                  })}
                                </Box>
                              </Grid>
                            </Grid>
                            <Box
                              onClick={() => {
                                dispatch(toggleFlightModal(true));
                                dispatch(setFlightId(item.ResultIndex));
                                dispatch(
                                  FlightFareRuleDispatch(
                                    item.ResultIndex,
                                    flightreturnInt &&
                                      flightreturnInt.result &&
                                      flightreturnInt.result.Response.TraceId
                                  )
                                );
                              }}
                            >
                              <span
                                style={{ color: "blue", cursor: "pointer" }}
                              >
                                Flight Details
                              </span>
                            </Box>
                            {/* <Box
														display='flex'
														justifyContent='space-between'
														mt={'5px'}>
														<Box
															onClick={() => handleInfo('fare')}
															style={{
																width: '100%',
																background: 'blue',
																marginLeft: '10px',
																textAlign: 'center',
																padding: '5px',
																borderRadius: '15px',
															}}>
															<span style={{ color: 'white' }}>
																Fare Details
															</span>
														</Box>
														<Box
															onClick={() => handleInfo('baggage')}
															style={{
																width: '100%',
																background: 'blue',
																marginLeft: '10px',
																textAlign: 'center',
																padding: '5px',
																borderRadius: '15px',
															}}>
															<span style={{ color: 'white' }}>
																Baggage Info
															</span>
														</Box>
													</Box>
													{info === 'fare' ? (
														<Box>
															<h2>Fare</h2>
														</Box>
													) : (
														''
													)}
													{info === 'baggage' ? (
														<Box>
															<h2>Baggage</h2>
														</Box>
													) : (
														''
													)} */}
                          </AccordionDetails>
                        </Accordion>
                      </>
                    ) : (
                      ""
                    );
                  })}
                </InfiniteScroll>
              ) : (
                <div
                  style={{
                    padding: "30px 15px",
                    background: "white",
                    borderBottom: "1px solid #e6e6e6",
                    textAlign: "center",
                  }}
                >
                  {/* <img src={flightnotfound}></img> */}
                  <p style={{ fontSize: "24px", textAlign: "center" }}>
                    Sorry No Flight Found !!
                  </p>
                </div>
              )
            ) : lint ? (
              [0, 1, 2, 3, 4].map((i) => {
                return <SkeletonOneway />;
              })
            ) : filterData && filterData.length > 0 ? (
              <InfiniteScroll
                dataLength={scrollVal}
                next={fetchMoreData}
                hasMore={hasMorefilterData}
                loader={<h4 style={{ textAlign: "center" }}>Loading...</h4>}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>No More Flights</b>
                  </p>
                }
              >
                {filterData.map((item, index) => {
                  return index < scrollVal ? (
                    <>
                      <Accordion
                        style={{ marginTop: 10 }}
                        expanded={expanded === `panel${index + 1}`}
                        onChange={handleChange(`panel${index + 1}`)}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={6} lg={6}>
                              <Box
                                alignItems="center"
                                display="flex"
                                justifyContent="space-between"
                              >
                                <Box style={{ display: "flex" }}>
                                  <img
                                    width="50px"
                                    height="50px"
                                    src={`https://nitish.musafirbazar.com/static/media/${item.Segments[0]
                                      .slice(0, 1)
                                      .map((i) => {
                                        return i.Airline.AirlineCode;
                                      })}.gif`}
                                  />
                                  <Box ml={"10px"}>
                                    <span>
                                      {item.Segments[0].slice(0, 1).map((i) => {
                                        return i.Airline.AirlineName;
                                      })}
                                    </span>
                                    <br></br>
                                    <span>
                                      {item.Segments[0].slice(0, 1).map((i) => {
                                        return i.Airline.AirlineCode;
                                      })}
                                    </span>
                                  </Box>
                                </Box>
                                <Box>
                                  <Box display="flex">
                                    <span style={{ fontWeight: "bold" }}>
                                      {item.Origin
                                        ? item.Origin
                                        : item.FareRules[0].Origin}
                                    </span>
                                    <span
                                      style={{
                                        marginLeft: 5,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      -
                                    </span>
                                    <span
                                      style={{
                                        marginLeft: 5,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {" "}
                                      {item.Airline_Code
                                        ? item.Segments.length === 1
                                          ? item.Segments.filter(
                                              (i, index) => index === 0
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 2
                                          ? item.Segments.filter(
                                              (i, index) => index === 1
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 3
                                          ? item.Segments.filter(
                                              (i, index) => index === 2
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : ""
                                        : item.Segments[0].length == 2
                                        ? item.Segments[0]
                                            .filter((i, index) => index === 1)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[0].length == 3
                                        ? item.Segments[0]
                                            .filter((i, index) => index === 2)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[0].length == 1
                                        ? item.Segments[0].map((it) => {
                                            return it.Destination.Airport
                                              .AirportCode;
                                          })
                                        : ""}
                                    </span>
                                    {/* <br></br> */}
                                  </Box>
                                  <span
                                    style={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                    }}
                                  >
                                    {item.Airline_Code
                                      ? item.Segments[0].Departure_DateTime.substr(
                                          11,
                                          5
                                        )
                                      : item.AirlineCode
                                      ? item.Segments[0]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Origin.DepTime.substr(
                                              11,
                                              5
                                            );
                                          })
                                      : ""}
                                    {/* {item.Segments[0].slice} */}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                    }}
                                  >
                                    -
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                    }}
                                  >
                                    {item.Airline_Code
                                      ? item.Segments.length === 1
                                        ? item.Segments.filter(
                                            (i, index) => index === 0
                                          ).map((it) => {
                                            return it.Departure_DateTime.substr(
                                              11,
                                              5
                                            );
                                          })
                                        : item.Segments.length === 2
                                        ? item.Segments.filter(
                                            (i, index) => index === 1
                                          ).map((it) => {
                                            return it.Departure_DateTime.substr(
                                              11,
                                              5
                                            );
                                          })
                                        : item.Segments.length === 3
                                        ? item.Segments.filter(
                                            (i, index) => index === 2
                                          ).map((it) => {
                                            return it.Departure_DateTime.substr(
                                              11,
                                              5
                                            );
                                          })
                                        : ""
                                      : item.AirlineCode
                                      ? item.Segments[0].length == 3
                                        ? item.Segments[0]
                                            .filter((i, index) => index === 2)
                                            .map((i) => {
                                              return i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : item.Segments[0].length == 2
                                        ? item.Segments[0]
                                            .filter((i, index) => index === 1)
                                            .map((i) => {
                                              return i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : item.Segments[0].length == 1
                                        ? item.Segments[0]
                                            .filter((i, index) => index === 0)
                                            .map((i) => {
                                              return i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : ""
                                      : ""}
                                  </span>
                                </Box>

                                <Box
                                  style={{ display: "flex" }}
                                  onClick={() =>
                                    data ? setData(false) : setData(true)
                                  }
                                >
                                  <img
                                    width="50px"
                                    height="50px"
                                    src={`https://nitish.musafirbazar.com/static/media/${item.Segments[1]
                                      .slice(0, 1)
                                      .map((i) => {
                                        return i.Airline.AirlineCode;
                                      })}.gif`}
                                  />
                                  <Box ml={"10px"}>
                                    <span>
                                      {item.Segments[1].slice(0, 1).map((i) => {
                                        return i.Airline.AirlineName;
                                      })}
                                    </span>
                                    <br></br>
                                    <span>
                                      {item.Segments[1].slice(0, 1).map((i) => {
                                        return i.Airline.AirlineCode;
                                      })}
                                    </span>
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item xs={6} lg={6}>
                              <Box
                                display="flex"
                                justifyContent="space-between"
                              >
                                <Box>
                                  <Box display="flex">
                                    <span style={{ fontWeight: "bold" }}>
                                      {item.Segments[1]
                                        .slice(0, 1)
                                        .map((it) => {
                                          return it.Origin.Airport.AirportCode;
                                        })}
                                    </span>
                                    <span
                                      style={{
                                        marginLeft: 5,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      -
                                    </span>
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        marginLeft: 5,
                                      }}
                                    >
                                      {" "}
                                      {item.Airline_Code
                                        ? item.Segments.length === 1
                                          ? item.Segments.filter(
                                              (i, index) => index === 0
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 2
                                          ? item.Segments.filter(
                                              (i, index) => index === 1
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : item.Segments.length === 3
                                          ? item.Segments.filter(
                                              (i, index) => index === 2
                                            ).map((it) => {
                                              return it.Destination;
                                            })
                                          : ""
                                        : item.Segments[1].length == 2
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 1)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[1].length == 3
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 2)
                                            .map((it) => {
                                              return it.Destination.Airport
                                                .AirportCode;
                                            })
                                        : item.Segments[1].length == 1
                                        ? item.Segments[1].map((it) => {
                                            return it.Destination.Airport
                                              .AirportCode;
                                          })
                                        : ""}
                                    </span>
                                    <br></br>
                                  </Box>
                                  <span
                                    style={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                    }}
                                  >
                                    {item.Airline_Code
                                      ? item.Segments[1].Departure_DateTime.substr(
                                          11,
                                          5
                                        )
                                      : item.AirlineCode
                                      ? item.Segments[1]
                                          .slice(0, 1)
                                          .map((i) => {
                                            return i.Origin.DepTime.substr(
                                              11,
                                              5
                                            );
                                          })
                                      : ""}
                                    {/* {item.Segments[0].slice} */}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                    }}
                                  >
                                    -
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                    }}
                                  >
                                    {item.Airline_Code
                                      ? item.Segments.length === 1
                                        ? item.Segments.filter(
                                            (i, index) => index === 0
                                          ).map((it) => {
                                            return it.Departure_DateTime.substr(
                                              11,
                                              5
                                            );
                                          })
                                        : item.Segments.length === 2
                                        ? item.Segments.filter(
                                            (i, index) => index === 1
                                          ).map((it) => {
                                            return it.Departure_DateTime.substr(
                                              11,
                                              5
                                            );
                                          })
                                        : item.Segments.length === 3
                                        ? item.Segments.filter(
                                            (i, index) => index === 2
                                          ).map((it) => {
                                            return it.Departure_DateTime.substr(
                                              11,
                                              5
                                            );
                                          })
                                        : ""
                                      : item.AirlineCode
                                      ? item.Segments[1].length == 3
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 2)
                                            .map((i) => {
                                              return i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : item.Segments[1].length == 2
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 1)
                                            .map((i) => {
                                              return i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : item.Segments[1].length == 1
                                        ? item.Segments[1]
                                            .filter((i, index) => index === 0)
                                            .map((i) => {
                                              return i.Destination.ArrTime.substr(
                                                11,
                                                5
                                              );
                                            })
                                        : ""
                                      : ""}
                                  </span>
                                </Box>

                                {/* <Box>
                       
                      </Box> */}

                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  {item.IsRefundable ? (
                                    <Box
                                      style={{
                                        border: "1px solid #2dca1c",
                                        padding: "2px 8px",
                                      }}
                                    >
                                      <span style={{ color: "#2dca1c" }}>
                                        R
                                      </span>
                                    </Box>
                                  ) : (
                                    <Box
                                      style={{
                                        border: "1px solid red",
                                        padding: "2px 8px",
                                      }}
                                    >
                                      <span style={{ color: "red" }}>N</span>
                                    </Box>
                                  )}
                                  <h3 style={{ marginLeft: 10 }}>
                                    {curr}{" "}
                                    {Number(
                                      Math.round(
                                        Number(
                                          Math.round(item.Fare.Total_Amount)
                                        )
                                      )
                                    )}
                                  </h3>
                                  <Box
                                    onClick={() => {
                                      history.push({
                                        pathname: "/summaryflight",
                                        state: {
                                          orderID: orderID?.result,
                                          // flightData:
                                          //   resultSelection.length == 1
                                          //     ? resultSelection
                                          //     : onward.length == 1
                                          //     ? onward
                                          //     : "",
                                          // selectedonward:
                                          //   selectedonward.length == 1
                                          //     ? selectedonward
                                          //     : "",
                                          // selectedReturn:
                                          //   selectedReturn.length == 1
                                          //     ? selectedReturn
                                          //     : "",

                                          // Returnflight:
                                          //   resultRSelection.length == 1
                                          //     ? resultRSelection
                                          //     : returnD.length == 1
                                          //     ? returnD
                                          //     : "",
                                          returnBody: location.state.returnBody,
                                          intFlight: item,
                                          // ID:
                                          //   flightreturn &&
                                          //   flightreturn.result &&
                                          //   flightreturn.result.Response &&
                                          //   flightreturn.result.Response.TraceId,
                                          IDTBO:
                                            flightreturnInt &&
                                            flightreturnInt.result &&
                                            flightreturnInt.result.Response &&
                                            flightreturnInt.result.Response
                                              .TraceId,
                                          // IDEtrav:
                                          //   roundTripEtrav &&
                                          //   roundTripEtrav.result &&
                                          //   roundTripEtrav.result.Search_Key,
                                        },
                                      });
                                    }}
                                    textAlign="center"
                                    style={{
                                      marginLeft: 20,
                                      background: "#ef631e",
                                      color: "white",
                                      borderRadius: "5px",
                                      padding: "0px 10px",
                                    }}
                                  >
                                    <h3>Book Now</h3>
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid container spacing={2}>
                            <Grid item xs={12} lg={6}>
                              {" "}
                              <Box
                                style={{ marginTop: 25 }}
                                display="flex"
                                justifyContent="space-between"
                              >
                                <span>Depart</span>
                                <Box>
                                  <span>Duration:</span>
                                  <span style={{ marginLeft: 10 }}>
                                    {timeConvert(
                                      item.AirlineCode
                                        ? item.Segments[0].length == 2
                                          ? Number(
                                              item.Segments[0]
                                                .filter(
                                                  (i, index) => index === 0
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            ) +
                                            Number(
                                              item.Segments[0]
                                                .filter(
                                                  (i, index) => index === 1
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            )
                                          : item.Segments[0].length == 1
                                          ? item.Segments[0].map(
                                              (i) => i.Duration
                                            )
                                          : item.Segments[0].length == 3
                                          ? Number(
                                              item.Segments[0]
                                                .filter(
                                                  (i, index) => index === 0
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            ) +
                                            Number(
                                              item.Segments[0]
                                                .filter(
                                                  (i, index) => index === 1
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            ) +
                                            Number(
                                              item.Segments[0]
                                                .filter(
                                                  (i, index) => index === 2
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            )
                                          : ""
                                        : ""
                                    )}
                                  </span>
                                </Box>
                              </Box>
                              <Box
                                style={{
                                  padding: 10,
                                  border: "1px solid #ebe5e5",
                                }}
                              >
                                {item.Segments[0].map((i) => {
                                  return (
                                    <>
                                      <Box
                                        display="flex"
                                        style={{ marginTop: 10 }}
                                        justifyContent="space-between"
                                      >
                                        {" "}
                                        <Box>
                                          <span>
                                            {i.Origin.Airport.AirportCode}
                                          </span>
                                          <span style={{ marginLeft: 5 }}>
                                            ({i.Origin.Airport.CityName})
                                          </span>
                                          <span
                                            style={{
                                              marginLeft: 5,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {i.Origin.DepTime.substr(11, 5)}
                                          </span>
                                        </Box>
                                        <Box style={{ textAlign: "center" }}>
                                          <span>{timeConvert(i.Duration)}</span>
                                          <div className="ln"></div>
                                          <br></br>
                                          <span style={{ marginLeft: 5 }}>
                                            Non Stop
                                          </span>
                                        </Box>
                                        <Box>
                                          <span>
                                            {i.Destination.Airport.AirportCode}
                                          </span>
                                          <span style={{ marginLeft: 5 }}>
                                            ({i.Destination.Airport.CityName})
                                          </span>
                                          <span
                                            style={{
                                              marginLeft: 5,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {i.Destination.ArrTime.substr(
                                              11,
                                              5
                                            )}
                                          </span>
                                        </Box>
                                      </Box>
                                    </>
                                  );
                                })}
                              </Box>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              {" "}
                              <Box
                                style={{ marginTop: 25 }}
                                display="flex"
                                justifyContent="space-between"
                              >
                                <span>Return</span>
                                <Box>
                                  <span>Duration:</span>
                                  <span style={{ marginLeft: 10 }}>
                                    {timeConvert(
                                      item.AirlineCode
                                        ? item.Segments[1].length == 2
                                          ? Number(
                                              item.Segments[1]
                                                .filter(
                                                  (i, index) => index === 0
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            ) +
                                            Number(
                                              item.Segments[1]
                                                .filter(
                                                  (i, index) => index === 1
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            )
                                          : item.Segments[1].length == 1
                                          ? item.Segments[1].map(
                                              (i) => i.Duration
                                            )
                                          : item.Segments[1].length == 3
                                          ? Number(
                                              item.Segments[1]
                                                .filter(
                                                  (i, index) => index === 0
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            ) +
                                            Number(
                                              item.Segments[1]
                                                .filter(
                                                  (i, index) => index === 1
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            ) +
                                            Number(
                                              item.Segments[1]
                                                .filter(
                                                  (i, index) => index === 2
                                                )
                                                .map((it) => {
                                                  return it.Duration;
                                                })
                                            )
                                          : ""
                                        : ""
                                    )}
                                  </span>
                                </Box>
                              </Box>
                              <Box
                                style={{
                                  padding: 10,
                                  border: "1px solid #ebe5e5",
                                }}
                              >
                                {item.Segments[1].map((i) => {
                                  return (
                                    <>
                                      <Box
                                        display="flex"
                                        style={{ marginTop: 10 }}
                                        justifyContent="space-between"
                                      >
                                        {" "}
                                        <Box>
                                          <span>
                                            {i.Origin.Airport.AirportCode}
                                          </span>
                                          <span style={{ marginLeft: 5 }}>
                                            ({i.Origin.Airport.CityName})
                                          </span>
                                          <span
                                            style={{
                                              marginLeft: 5,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {i.Origin.DepTime.substr(11, 5)}
                                          </span>
                                        </Box>
                                        <Box style={{ textAlign: "center" }}>
                                          <span>{timeConvert(i.Duration)}</span>
                                          <div className="ln"></div>
                                          <br></br>
                                          <span style={{ marginLeft: 5 }}>
                                            Non Stop
                                          </span>
                                        </Box>
                                        <Box>
                                          <span>
                                            {i.Destination.Airport.AirportCode}
                                          </span>
                                          <span style={{ marginLeft: 5 }}>
                                            ({i.Destination.Airport.CityName})
                                          </span>
                                          <span
                                            style={{
                                              marginLeft: 5,
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {i.Destination.ArrTime.substr(
                                              11,
                                              5
                                            )}
                                          </span>
                                        </Box>
                                      </Box>
                                    </>
                                  );
                                })}
                              </Box>
                            </Grid>
                          </Grid>
                          <Box
                            onClick={() => {
                              dispatch(toggleFlightModal(true));
                              dispatch(setFlightId(item.ResultIndex));
                              dispatch(
                                FlightFareRuleDispatch(
                                  item.ResultIndex,
                                  flightreturnInt &&
                                    flightreturnInt.result &&
                                    flightreturnInt.result.Response.TraceId
                                )
                              );
                            }}
                          >
                            <span style={{ color: "blue", cursor: "pointer" }}>
                              Flight Details
                            </span>
                          </Box>
                          {/* <Box
														display='flex'
														justifyContent='space-between'
														mt={'5px'}>
														<Box
															onClick={() => handleInfo('fare')}
															style={{
																width: '100%',
																background: 'blue',
																marginLeft: '10px',
																textAlign: 'center',
																padding: '5px',
																borderRadius: '15px',
															}}>
															<span style={{ color: 'white' }}>
																Fare Details
															</span>
														</Box>
														<Box
															onClick={() => handleInfo('baggage')}
															style={{
																width: '100%',
																background: 'blue',
																marginLeft: '10px',
																textAlign: 'center',
																padding: '5px',
																borderRadius: '15px',
															}}>
															<span style={{ color: 'white' }}>
																Baggage Info
															</span>
														</Box>
													</Box>
													{info === 'fare' ? (
														<Box>
															<h2>Fare</h2>
														</Box>
													) : (
														''
													)}
													{info === 'baggage' ? (
														<Box>
															<h2>Baggage</h2>
														</Box>
													) : (
														''
													)} */}
                        </AccordionDetails>
                      </Accordion>
                    </>
                  ) : (
                    ""
                  );
                })}
              </InfiniteScroll>
            ) : (
              <div
                style={{
                  padding: "30px 15px",
                  background: "white",
                  borderBottom: "1px solid #e6e6e6",
                  textAlign: "center",
                }}
              >
                {/* <img src={flightnotfound}></img> */}
                <p style={{ fontSize: "24px", textAlign: "center" }}>
                  Sorry No Flight Found !!
                </p>
              </div>
            )}
          </Grid>
        </Grid>
      </Box>
      <FlightDetailModal />
      {/* </Container> */}
    </>
  );
};

export default International;
